import { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../lib/supabase';

const INK    = '#0d0d0d';
const BLUE   = '#1755f4';
const MUTED  = '#888';
const BORDER = '#e8e8e8';

const inputStyle = {
  width: '100%', border: `1px solid ${BORDER}`, borderRadius: 0,
  padding: '10px 12px', fontSize: '13px', boxSizing: 'border-box',
  fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
  color: INK, background: 'white', outline: 'none',
};

export default function ForgotPassword() {
  const [email, setEmail]   = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone]     = useState(false);
  const [error, setError]   = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { error: err } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset-password`,
    });
    if (err) {
      setError('Fehler: ' + err.message);
      setLoading(false);
    } else {
      setDone(true);
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: '100vh', background: '#fafafa',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif", padding: '24px',
    }}>
      <div style={{ width: '100%', maxWidth: '400px' }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div style={{ fontSize: '15px', fontWeight: 900, letterSpacing: '3px', textTransform: 'uppercase', color: INK }}>
            IMMO<span style={{ color: BLUE }}>HQ</span>
          </div>
        </div>

        {done ? (
          /* Success state */
          <div style={{ background: 'white', border: `1px solid ${BORDER}`, padding: '40px 32px', textAlign: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', justifyContent: 'center', marginBottom: '24px' }}>
              <div style={{ width: '24px', height: '1px', background: INK }} />
              <span style={{ fontSize: '9px', fontWeight: 700, letterSpacing: '3px', textTransform: 'uppercase', color: INK }}>
                E-Mail gesendet
              </span>
              <div style={{ width: '24px', height: '1px', background: INK }} />
            </div>
            <h1 style={{ fontSize: '22px', fontWeight: 900, letterSpacing: '-0.5px', color: INK, marginBottom: '16px' }}>
              Prüfe dein Postfach
            </h1>
            <p style={{ fontSize: '13px', color: MUTED, lineHeight: 1.7, marginBottom: '32px' }}>
              Wir haben einen Link zum Zurücksetzen deines Passworts an{' '}
              <strong style={{ color: INK }}>{email}</strong> gesendet. Bitte prüfe auch deinen Spam-Ordner.
            </p>
            <Link to="/login" style={{
              display: 'block', background: INK, color: 'white', border: 'none',
              padding: '13px', fontSize: '11px', fontWeight: 700,
              letterSpacing: '1px', textTransform: 'uppercase', textAlign: 'center',
              textDecoration: 'none',
            }}>
              Zurück zum Login
            </Link>
          </div>
        ) : (
          /* Form */
          <div style={{ background: 'white', border: `1px solid ${BORDER}`, padding: '40px 32px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
              <div style={{ width: '24px', height: '1px', background: INK }} />
              <span style={{ fontSize: '9px', fontWeight: 700, letterSpacing: '3px', textTransform: 'uppercase', color: INK }}>
                Passwort zurücksetzen
              </span>
            </div>
            <h1 style={{ fontSize: '22px', fontWeight: 900, letterSpacing: '-0.5px', color: INK, marginBottom: '8px' }}>
              Passwort vergessen?
            </h1>
            <p style={{ fontSize: '13px', color: MUTED, lineHeight: 1.6, marginBottom: '32px' }}>
              Gib deine E-Mail-Adresse ein und wir schicken dir einen Link zum Zurücksetzen.
            </p>

            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', fontSize: '9px', fontWeight: 700, letterSpacing: '2px', textTransform: 'uppercase', color: MUTED, marginBottom: '8px' }}>
                  E-Mail-Adresse
                </label>
                <input
                  type="email" required
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="name@firma.de"
                  style={inputStyle}
                />
              </div>

              {error && (
                <div style={{ border: `1px solid #fca5a5`, background: '#fef2f2', padding: '10px 14px', fontSize: '12px', color: '#b91c1c', marginBottom: '20px' }}>
                  {error}
                </div>
              )}

              <button type="submit" disabled={loading} style={{
                width: '100%', background: loading ? MUTED : INK, color: 'white', border: 'none',
                padding: '13px', fontSize: '11px', fontWeight: 700,
                letterSpacing: '1px', textTransform: 'uppercase',
                cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'inherit',
                marginBottom: '16px',
              }}>
                {loading ? 'Wird gesendet...' : 'Link senden'}
              </button>
            </form>

            <div style={{ textAlign: 'center' }}>
              <Link to="/login" style={{ fontSize: '12px', color: MUTED, letterSpacing: '0.3px', textDecoration: 'none' }}>
                ← Zurück zum Login
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
